<div class="driver-modal">
  <div class="sec_head">
    <h2>{{ 'AssignDriver' | translate }}</h2>
  </div>
  <div class="modal-body">
    <div id="page-content-wrapper">
      <ng-container *ngIf="dataSource && dataSource.length; else noData">
        <div class="rpt_card cust_tab tables">
          <mat-table #table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="position">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >#</mat-header-cell
              >
              <mat-cell *matCellDef="let element; let i = index">
                {{ i + 1 }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="driverimage">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >{{ 'DriverImage' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div class="usr_dtl">
                  <figure class="usr_img">
                    <img
                      [src]="
                        element.image ? element.image : assetsConst.placeHolder
                      " />
                  </figure>
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="driverdetail">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >{{ 'DriverDetail' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div class="usr_dtl">
                  <div class="usr_abt">
                    <p>{{ element?.name }}</p>
                    <p>{{ element?.email }}</p>
                    <p>{{ element?.dialCode }} {{ element?.phoneNo }}</p>
                  </div>
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="type">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >{{ 'VehicleType' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.vehicleCategory?.name }}
              </mat-cell>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
      </ng-container>
      <ng-template #noData>
        <megastore-admin-no-data-found></megastore-admin-no-data-found>
      </ng-template>
    </div>
  </div>
</div>
